import { createSelector } from '@reduxjs/toolkit';
import { User } from '../models/user';
import { AppState, userSelector } from '../store/store';

export const selectAuthorisedEmailUser = createSelector([
    (state: AppState) => userSelector.selectAll(state),
    (_state: AppState, email: string) => email
], (users: User[], email: string) => {
    if (!email) return null;
    return users.find(p => p.email == email);
}
);

export const userLogged = createSelector([
    (state: AppState) => userSelector.selectAll(state),
    (state: AppState) => state.device.user,
], (users: User[], user?: User) => {
    if (user) {
        return users.find(p => p.id === user.id);
    } else return null;
}
);
